// ============================================
// Scroll Animate Module
// Fade in elements as they enter viewport using Intersection Observer
// ============================================

/**
 * Initialize scroll animations
 * Elements with .js-animate class fade in when entering viewport
 */
export function initScrollAnimate() {
  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  const animatedElements = document.querySelectorAll('.js-animate');

  if (animatedElements.length === 0) return;

  // If reduced motion is preferred, show elements immediately without animation
  if (prefersReducedMotion) {
    animatedElements.forEach((el) => {
      el.classList.add('is-visible');
    });
    return;
  }

  /**
   * Intersection Observer callback
   * Adds is-visible class when element enters viewport
   */
  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        // Unobserve after first intersection (animate once only)
        observer.unobserve(entry.target);
      }
    });
  };

  // Create observer with 0.1 threshold (10% visible triggers animation)
  const observer = new IntersectionObserver(observerCallback, {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  });

  // Observe all animated elements
  animatedElements.forEach((el) => {
    observer.observe(el);
  });
}
